export default {
  DARK: {
    border: () => 'none',
    shadow: () => 'none',
    buttonShadow: () => 'none',
    raisedShadow: () => 'none',
    heading: p => p.primaryLight,
    background: p => p.tertiaryDark,
    icon: p => p.primaryLight,
    border: p => p.primaryLight,
    backgroundColor: p => p.tertiaryDark
  },
  LIGHT: {
    heading: p => p.primaryDark,
    background: p => p.tertiaryLight,
    icon: p => p.primaryDark,
    border: p => p.primaryDark,
    backgroundColor: p => p.tertiaryLight
  },
  EXTRALIGHT: {
    heading: p => p.tertiaryDark,
    background: p => p.tertiaryLight,
    icon: p => p.tertiaryDark,
    border: p => p.primaryLight,
    background: p => p.tertiaryExtraLight,
    backgroundColor: p => p.tertiaryExtraLight
  }
}
